'use client'

import Link from 'next/link'
import { useEffect } from 'react'

 
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {

  useEffect(() => {
    console.error('global error', JSON.stringify(error));
  }, [error]);
  return (
    <html lang='ar' dir='rtl'>
      <body>
      <div className="h-full flex flex-col justfy-center items-center gap-y-[24px] px-[16px] desktop:px-0 w-full max-w-[1296px] mx-auto pt-[48px]">
      <span className="h1 text-black dark:text-white">الموقع قيد الصيانة حالياً.</span>
      <span className='h1 text-black dark:text-white'>نعمل على تحسين تجربتك وسنعود قريباً.</span>
      <a href='/' title='الصفحة الرئيسية' className='self-center grid place-items-center h-[62px] w-fit md bg-primary text-white p-[16px] px-[24px] rounded-[4px] mb-[24px]'>العودة إلى الصفحة الرئيسية</a>
    </div>
      </body>
    </html>
  )
}